import { useState, useEffect } from 'react';
import { Box, Grid, LinearProgress } from '@mui/material';
import { useHistory } from 'react-router';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { Formik } from 'formik';
import { AddAmcAdminRequestBody, AmcAdmin } from '../../redux-store/types/api-types';
import { useDispatch } from 'react-redux';
import {
  addAmcAdmin,
  AmcAdminAccess,
  getAmcAdminAccess,
  getAMCAdminById,
  updateAmcAdmin,
} from '../../redux-store/actions/userManagement';
import { amcAdminSchema } from '../../utils/schema';
import { Location } from 'history';
import { CountryCodesDropDown } from '../commonComponents';
import { BackButtonAndHeader } from './userBackButton';
import { styles } from '../../Styles/styles';

const initialValues: AddAmcAdminRequestBody = {
  name: '',
  email: '',
  countryNameAndCode: 'India: +91',
  countryCode: '+91',
  phone: '',
  isActive: true,
};

export default function AddAmcAdmin({
  location,
}: {
  location: Location<{ amcAdminId: number }>;
}): JSX.Element {
  const { amcAdminId } = location.state || {};
  const history = useHistory();
  const dispatch = useDispatch();
  const [accessForEditAdd, setAccessForEditAdd] = useState(false);

  const [amcAdminDetails, setAmcAdminDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setLoading(true);
        const { amcAdminAccess } = (await dispatch(
          getAmcAdminAccess()
        )) as unknown as AmcAdminAccess;
        if (amcAdminId) {
          const getAmcAdminDetails = (await dispatch(
            getAMCAdminById(amcAdminId)
          )) as unknown as AmcAdmin;
          const {
            firstName: name,
            phone,
            email,
            countryCode,
            countryNameAndCode,
          } = getAmcAdminDetails.user;
          setAmcAdminDetails({
            ...amcAdminDetails,
            id: getAmcAdminDetails.id,
            name: name as string,
            phone,
            email,
            countryNameAndCode: (countryNameAndCode ? countryNameAndCode : 'India: +91') as string,
            countryCode: (countryCode ? countryCode : '+91') as string,
            isActive: getAmcAdminDetails.isActive,
          });
        }
        if (!isComponentAlive) return;
        setAccessForEditAdd(amcAdminAccess);
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isComponentAlive = false;
    };
  }, []);

  const onSubmit = async (values: AddAmcAdminRequestBody) => {
    try {
      if (!amcAdminId) {
        await dispatch(
          addAmcAdmin({
            ...values,
            countryCode: values.countryNameAndCode?.split(':')[1].trim(),
          })
        );
        history.push('amc-admin');
      } else {
        await dispatch(
          updateAmcAdmin(amcAdminId, {
            ...values,
            countryCode: values.countryNameAndCode?.split(':')[1].trim(),
          })
        );
        history.push('amc-admin-details', { amcAdminId });
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Formik
        initialValues={amcAdminDetails}
        onSubmit={onSubmit}
        enableReinitialize={true}
        validationSchema={amcAdminSchema}>
        {({ handleSubmit, values }) => (
          <Box sx={styles.UsersFormikBox} component="form" noValidate onSubmit={handleSubmit}>
            <BackButtonAndHeader
              User={amcAdminId ? 'AMC Admin' : 'Onboarding AMC Admin'}
              onClickBack={() =>
                amcAdminId
                  ? history.push('amc-admin-details', { amcAdminId: values.id })
                  : history.push('amc-admin')
              }
            />
            {loading ? (
              <LinearProgress />
            ) : (
              <>
                <Grid container rowSpacing={1} columnSpacing={4} px={4} pt={3}>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="name"
                      label="Name *"
                      placeholder="Enter Name"
                      disabled={!accessForEditAdd}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="email"
                      label="Email Id *"
                      placeholder="Enter Email Id"
                      disabled={!accessForEditAdd}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="phone"
                      label="Mobile Number *"
                      placeholder="Enter Mobile Number"
                      // startAdornment={
                      //   <CountryCodesDropDown
                      //     name={`countryNameAndCode`}
                      //     value={values.countryNameAndCode}
                      //   />
                      // }
                      disabled={!accessForEditAdd}
                    />
                  </Grid>
                </Grid>
                {accessForEditAdd && (
                  <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 3 }}>
                    <MFSubmitButton label="Save" />
                  </Box>
                )}
              </>
            )}
          </Box>
        )}
      </Formik>
    </>
  );
}
